import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  Checkbox,
  Label,
  Pagination,
  Table,
} from "flowbite-react";
import { FaArrowsLeftRight } from "react-icons/fa6";
import axios from "../../config/axiosInstance";
import { useQuery, useQueryClient } from "react-query";
import { ADMIN } from "../../config/apiConfig";
import { formatToReal } from "../../utils/utils";
import AutoCompleteInput from "../inputs/Autocomplete";
import EmptyTable from "./EmptyTable";
import { BsFillBarChartFill } from "react-icons/bs";
import DrawerLoading from "../DrawerLoading";
import TableLoading from "../TableLoading";
import { FaRegEdit, FaUsers } from "react-icons/fa";
import UserForm from "../forms/UserForm";
import Drawer from "../Drawer";
import { Tooltip } from "react-tooltip";
import { IoMdAdd, IoMdSearch } from "react-icons/io";
import { LuFilter, LuFilterX } from "react-icons/lu";

const AdminUsersTableSpecific = ({ companyId, isActive }) => {
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPriceSum, setTotalPriceSum] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const onPageChange = (page) => setCurrentPage(page);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isDrawerEditUser, setIsDrawerEditUser] = useState(false);
  const [isDrawerOpenUser, setIsDrawerOpenUser] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showFilters, setShowFilters] = useState(true);
  const [renderFilters, setRenderFilters] = useState(false);

  useEffect(() => {
    if (showFilters) {
      setRenderFilters(true); // mostra o conteúdo imediatamente
    } else {
      // espera a animação terminar antes de esconder
      const timeout = setTimeout(() => setRenderFilters(false), 500); // mesmo tempo da transition
      return () => clearTimeout(timeout);
    }
  }, [showFilters]);

  const {
    isLoading: isLoadingListUsers,
    error: errorListUsers,
    data: listUsers,
  } = useQuery(
    [
      "listUsers",
      currentPage,
      selectedStatuses,
      startDate,
      endDate,
      companyId,
      nameParam,
    ],
    async () => {
      const { data } = await axios.get(
        `${ADMIN.GET_USERS}?page=${currentPage}&status=${selectedStatuses}&companyId=${companyId}&startDate=${startDate}&endDate=${endDate}&search=${nameParam}`
      );

      setTotalPages(data.data.totalPages || 1);
      setTotalCount(data.data.totalCount || 0);

      return data.data.data;
    },
    { enabled: isActive }
  );

  const handleSearchName = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  const handleCheckboxChange = (status, setState) => {
    setState((prev) =>
      prev.includes(status)
        ? prev.filter((item) => item !== status)
        : [...prev, status]
    );
  };

  // const handleSearchName = (e) => {
  //   e.preventDefault();
  //   setNameParam(searchName);
  // };

  const handleAddProfessional = () => {
    setSelectedUser(null);
    setIsDrawerOpenUser((prevState) => !prevState);
  };

  const handleEditCustomer = (user) => {
    setSelectedUser(user);
    setIsDrawerEditUser((prevState) => !prevState);
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <Button
          size="xs"
          onClick={() => setShowFilters((prev) => !prev)}
          className="primary text-white transition-all duration-300"
        >
          <div className="flex items-center gap-2 transition-all duration-300">
            <span>{showFilters ? "Esconder filtros" : "Mostrar filtros"}</span>
            <span className={`transition-transform duration-300 `}>
              {!showFilters ? <LuFilter /> : <LuFilterX />}
            </span>
          </div>
        </Button>
      </div>
      <div className="flex flex-col gap-4">
        {showFilters && (
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden bg-white rounded-md shadow-sm border border-gray-200 p-4 relative`}
          >
            {renderFilters && (
              <div className="transition-opacity duration-500 min-w-[200px]">
                <div className="title-syncx">Filtro avançado</div>

                <div className="flex flex-col md:flex-row gap-2 md:gap-20">
                  <div>
                    <div className="font-semibold mt-4 text-sm mb-2">
                      Criado em
                    </div>
                    <div className="flex items-center gap-1">
                      <input
                        type="date"
                        value={startDate}
                        onChange={(e) => {
                          setStartDate(e.target.value);
                          if (moment(e.target.value).isAfter(moment(endDate))) {
                            setEndDate(e.target.value);
                          }
                        }}
                        className="w-full block py-3 md:py-2 px-2 rounded-md text-xs text-gray-600 bg-gray-100 border-0 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer"
                      />
                      <div className="text-xs">Até</div>
                      <input
                        type="date"
                        value={endDate}
                        onChange={(e) => {
                          setEndDate(e.target.value);
                        }}
                        min={startDate}
                        className="w-full block py-3 md:py-2 px-2 rounded-md text-xs text-gray-600 bg-gray-100 border-0 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer"
                      />
                    </div>
                  </div>
                  <div className="mt-4 text-sm">
                    <div className="font-semibold">Status</div>
                    <ul className="mt-3 flex flex-col gap-2 md:flex-row md:gap-4">
                      <div className="flex items-center gap-2">
                        <Checkbox
                          id="ativo"
                          checked={selectedStatuses.includes(1)}
                          onChange={() =>
                            handleCheckboxChange(1, setSelectedStatuses)
                          }
                        />
                        <Label htmlFor="ativo" className="flex">
                          Ativo
                        </Label>
                      </div>
                      <div className="flex items-center gap-2">
                        <Checkbox
                          id="Bloqueado"
                          checked={selectedStatuses.includes(0)} // 0 = Falha
                          onChange={() =>
                            handleCheckboxChange(0, setSelectedStatuses)
                          }
                        />
                        <Label htmlFor="Bloqueado" className="flex">
                          Bloqueado
                        </Label>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        <div className="flex-1">
          <div className="title-syncx mt-3 mb-4">Resultado da busca</div>
          <div className="overflow-x-auto">
            <div className="flex gap-4 pb-3 min-w-[500px]">
              {/* Card - Total de Usuários */}
              <div className="min-w-[200px] flex-1 rounded-2xl p-4 shadow-md text-white bg-gradient-to-br from-[#1E3A8A] to-[#3B82F6] relative">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm opacity-90">Total de Usuários</p>
                    <h2 className="text-2xl font-bold mt-1">
                      {!isLoadingListUsers ? (
                        totalCount
                      ) : (
                        <div className="animate-pulse h-6 bg-white/30 rounded w-20" />
                      )}
                    </h2>
                  </div>
                  <BsFillBarChartFill className="text-white text-4xl opacity-20" />
                </div>
              </div>

              {/* Card - Usuários Ativos */}
              <div className="min-w-[200px] flex-1 rounded-2xl p-4 shadow-md text-white bg-gradient-to-br from-[#065F46] to-[#10B981] relative">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm opacity-90">Usuários Ativos</p>
                    <h2 className="text-2xl font-bold mt-1">
                      {!isLoadingListUsers ? (
                        totalCount
                      ) : (
                        <div className="animate-pulse h-6 bg-white/30 rounded w-20" />
                      )}
                    </h2>
                  </div>
                  <FaUsers className="text-white text-4xl opacity-20" />
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end mb-3 mt-4">
            <Button
              className="primary ml-auto md:ml-0 mb-5 md:mb-0 fixed md:relative bottom-4 md:bottom-0 right-6 md:right-0 z-10 md:z-0 rounded-full md:rounded-md shadow-lg md:shadow-md h-14 md:h-auto w-14 md:w-auto flex md:block justify-center items-center"
              variant="contained"
              disabled={isLoadingListUsers ? true : false}
              onClick={handleAddProfessional}
            >
              <IoMdAdd className="block md:hidden text-2xl" />

              <span className="hidden md:block">Adicionar usuário</span>
            </Button>
          </div>

          <form
            className="flex gap-1 mt-5 w-full pl-3 pr-2 py-2 md:py-1 rounded-md shadow-sm bg-gray-300"
            onSubmit={handleSearchName}
          >
            <input
              type="text"
              placeholder="Busque por nome do usuário..."
              className="border-0 py-1 text-sm mt-1 focus:outline-none focus:ring-0 focus:border-gray-300 px-0 w-full bg-gray-300 placeholder:text-gray-700"
              onChange={(e) => setSearchName(e.target.value)}
              value={searchName}
            />
            <Button
              size="sm"
              className="flex items-center bg-secondary w-20"
              type="submit"
            >
              <IoMdSearch />
            </Button>
          </form>

          <small
            className="gap-2 items-center mt-5 mb-1 flex md:hidden justify-center"
            style={{ fontSize: 10 }}
          >
            <span>
              Deslize para o lado para visualizar todas as informações
            </span>{" "}
            <FaArrowsLeftRight />
          </small>
          {listUsers?.length > 0 || isLoadingListUsers ? (
            <div className="overflow-x-auto shadow-sm rounded-lg mt-0 md:mt-5">
              <Table striped style={{ fontSize: "13px" }}>
                <Table.Head>
                  <Table.HeadCell className="text-center bg-gray-300">
                    Código de acesso
                  </Table.HeadCell>
                  <Table.HeadCell className="text-center bg-gray-300">
                    Usuário
                  </Table.HeadCell>
                  <Table.HeadCell className="text-center bg-gray-300">
                    E-mail
                  </Table.HeadCell>
                  <Table.HeadCell className="text-center bg-gray-300">
                    Permissão
                  </Table.HeadCell>
                  <Table.HeadCell className="text-center bg-gray-300">
                    Ações
                  </Table.HeadCell>
                </Table.Head>

                <Table.Body className="divide-y">
                  {!isLoadingListUsers ? (
                    <>
                      {listUsers?.length > 0 && (
                        <>
                          {listUsers.map((user, index) => (
                            <Table.Row
                              key={index}
                              className="bg-white dark:border-gray-700 dark:bg-gray-800"
                            >
                              <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                                {user.accessCode || "-"}
                              </Table.Cell>
                              <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                                {user.name}
                              </Table.Cell>
                              <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                                {user.email}
                              </Table.Cell>
                              <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                                {user.permissionId}
                              </Table.Cell>
                              <Table.Cell className="text-center py-2">
                                <div className="flex gap-2 justify-center items-center flex-wrap">
                                  <Tooltip
                                    id="tooltip-edit-user"
                                    content="Editar Usuário"
                                  />
                                  <FaRegEdit
                                    data-tooltip-id="tooltip-edit-user"
                                    fontSize="18"
                                    onClick={() => handleEditCustomer(user)}
                                    className="text-gray-500 cursor-pointer"
                                  />
                                </div>
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </>
                      )}
                    </>
                  ) : (
                    <TableLoading cols={5} />
                  )}
                </Table.Body>
              </Table>
            </div>
          ) : (
            <EmptyTable icon="search_off">
              Nenhum registro encontrado com esses filtros
            </EmptyTable>
          )}

          {totalPages > 1 && (
            <div className="flex overflow-x-auto justify-center mt-3">
              <Pagination
                layout="pagination"
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
                previousLabel=""
                nextLabel=""
                showIcons
              />
            </div>
          )}
        </div>

        <Drawer
          title={`Editar cliente`}
          onClose={setIsDrawerEditUser}
          isOpen={isDrawerEditUser}
          className={"w-full md:w-4/6 lg:w-2/6"}
        >
          <UserForm
            user={selectedUser}
            onClose={setIsDrawerEditUser}
            isOpen={isDrawerEditUser}
            type={"EDIT"}
            fetchUsers={() => {
              queryClient.invalidateQueries(["listUsers"]);
            }}
          />
        </Drawer>

        <Drawer
          title={"Criar usuário"}
          onClose={setIsDrawerOpenUser}
          isOpen={isDrawerOpenUser}
          className={"w-full md:w-4/6 lg:w-2/6"}
        >
          <UserForm
            onClose={setIsDrawerOpenUser}
            isOpen={isDrawerOpenUser}
            type={"CREATE"}
            fetchUsers={() => {
              queryClient.invalidateQueries(["listUsers"]);
            }}
            companyId={companyId}
          />
        </Drawer>
      </div>
    </div>
  );
};

export default AdminUsersTableSpecific;
